export enum PriceType {
  Once = "once",
  Monthly = "monthly",
  Free = "free",
}
